//Install
import React, { Component } from "react";
//Install
import { Row, Col } from "react-bootstrap";
//Install
import YL3158 from "../../Media/Image/052.jpg";

//Element
class K820Q1 extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement(Row, {},
            //Element
            React.createElement(Col, { md: 5 },
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB f029qa" },
                    //Element
                    React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB q035zf" },
                        //Element
                        "02"
                    ),
                    //Element
                    React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB g371o1" },
                        //Element
                        "Yenilenebilir Enerji"
                    ),
                    //Element
                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB tv2821" },
                        //Element
                        "Geleceği Güçlendiren,",
                        //Element
                        React.createElement("br", {}),
                        //Element
                        React.createElement("em", {},
                            //Element
                            "Sürdürülebilir"
                        ),
                        //Element
                        React.createElement("br", {}),
                        //Element
                        "Hizmetler"
                    )
                )
            ),
            //Element
            React.createElement(Col, { md: 7 },
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB j392d8" },
                    //Element
                    React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB u3177a" },
                        //Element
                        React.createElement("img", { alt: "Yenilenebilir Enerji", title: "Yenilenebilir Enerji", src: YL3158, width: "856", height: "auto" })
                    ),
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB a725gw" },
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "Yenilenebilir Enerji, Güneş, Rüzgâr, Yağmur ve Jeotermal Isı Gibi Doğal Süreçlerden Elde Edilen Sürekli Olarak Kendini Yenileyebilen Kaynaklara Dayalı Enerji Türüdür. Çevre Dostu Yapısı, Sürdürülebilirliği Doğrultusunda Geleceğin Enerji İhtiyacını Karşılamada Önemli Bir Rol Üstelenmektedir."
                        ),
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "Küresel İklim Krizi Temelinde Dünya'yı Tehdit Eden Çeşitli Faktörlere Karşı Sürdürülebilirlik Hedefleri Doğrultusunda Fosil Yakıtların Yerine Yenilenebilir Enerji Kaynaklarının Kullanımı Hızla Artmaktadır."
                        ),
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "Temas, Yenilenebilir Enerji Alanında; Çatı, Cephe, Arazi ve Tarımsal Uygulamalara Yönelik Güneş Enerji Santralleri İle Rüzgar Enerji Santrallerinin Anahtar Teslim Kurulum Hizmetlerini Sunmaktadır."
                        ),
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "Bununla Birlikte, Ek Olarak Kurulum Sonrası Garanti, Bakım, İşletme Hizmetleride Sunulmaktadır."
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default K820Q1;